"use strict";

exports.__esModule = true;
exports.getDataSeries = void 0;
var _SeriesOptions = require("./SeriesOptions");
var _constants = require("../constants");
var _pieChartPositioningOnLayoutOptions = require("./SeriesOptions/pieChartPositioningOnLayoutOptions");
var _pieChartDataAggregator = require("./pieChartDataAggregator");
var getDataSeries = exports.getDataSeries = function getDataSeries(data, device, dataItems, options, targetValue, valueFormatter, uiModern) {
  var _options$chartItems;
  if (uiModern === void 0) {
    uiModern = false;
  }
  var deviceName = device.name;
  var series = [];
  if (!data || !dataItems) {
    return [];
  }
  options == null || (_options$chartItems = options.chartItems) == null || (_options$chartItems = _options$chartItems.props) == null || _options$chartItems.forEach(function (chartItem, index) {
    if (chartItem.chartType === _constants.CHART_PIE) {
      var _options$chartItems2;
      var _pieChartPositioningO = (0, _pieChartPositioningOnLayoutOptions.pieChartPositioningOnLayoutOptions)(options == null || (_options$chartItems2 = options.chartItems) == null ? void 0 : _options$chartItems2.layout, index),
        center = _pieChartPositioningO.center,
        radius = _pieChartPositioningO.radius;
      var chartData = [];
      var angleSettings = chartItem == null ? void 0 : chartItem.angle;
      var ringSettings = chartItem == null ? void 0 : chartItem.ring;
      var basicConfig = chartItem == null ? void 0 : chartItem.basicConfig;
      for (var _i = 0, _Object$entries = Object.entries(data); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _Object$entries[_i],
          _ = _Object$entries$_i[0],
          groupedData = _Object$entries$_i[1];
        var _loop = function _loop() {
          var _Object$entries2$_i = _Object$entries2[_i2],
            key = _Object$entries2$_i[0],
            value = _Object$entries2$_i[1];
          var dataItem = dataItems == null ? void 0 : dataItems.find(function (item) {
            return item.name === key;
          });
          var aggrMethod = basicConfig == null ? void 0 : basicConfig.aggrMethod;
          chartData.push({
            name: generateDisplayName(dataItem, deviceName, options == null ? void 0 : options.controls),
            value: (0, _pieChartDataAggregator.getPieChartDataAggregator)(aggrMethod)(value),
            itemStyle: {
              color: dataItem == null ? void 0 : dataItem.color
            }
          });
        };
        for (var _i2 = 0, _Object$entries2 = Object.entries(groupedData); _i2 < _Object$entries2.length; _i2++) {
          _loop();
        }
      }
      var label = {
        show: basicConfig == null ? void 0 : basicConfig.showLabelsOutside,
        position: "outside"
      };
      var emphasis = {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        }
      };
      var labelLine = {
        show: true
      };
      var radiusSetting = ringSettings != null && ringSettings.useRing ? calculateRingWidth(radius, ringSettings == null ? void 0 : ringSettings.ringWidthPercentage) : ["0%", radius + "%"];
      if (ringSettings != null && ringSettings.useRing && ringSettings != null && ringSettings.showLabelInside) {
        label.show = false;
        label.position = "center";
        emphasis.label = {
          show: true,
          fontSize: 20,
          fontWeight: "bold"
        };
        labelLine.show = false;
      }
      var pieChartSeries = {
        type: _constants.CHART_PIE,
        radius: radiusSetting,
        center: center,
        data: chartData,
        padAngle: basicConfig == null ? void 0 : basicConfig.padAngle,
        itemStyle: {
          borderRadius: basicConfig == null ? void 0 : basicConfig.borderRadius
        },
        label: label,
        emphasis: emphasis,
        labelLine: labelLine
      };
      if (angleSettings != null && angleSettings.notFullCircle) {
        var startAngle = angleSettings == null ? void 0 : angleSettings.startAngle;
        var endAngle = angleSettings == null ? void 0 : angleSettings.endAngle;
        pieChartSeries.startAngle = calculateRingAngle(-startAngle);
        pieChartSeries.endAngle = calculateRingAngle(endAngle);
      }
      series.push(pieChartSeries);
    } else {
      for (var _i3 = 0, _Object$entries3 = Object.entries(data); _i3 < _Object$entries3.length; _i3++) {
        var _Object$entries3$_i = _Object$entries3[_i3],
          _2 = _Object$entries3$_i[0],
          _groupedData = _Object$entries3$_i[1];
        var _loop2 = function _loop2() {
          var _Object$entries4$_i = _Object$entries4[_i4],
            key = _Object$entries4$_i[0],
            value = _Object$entries4$_i[1];
          var dataItem = dataItems == null ? void 0 : dataItems.find(function (item) {
            return item.name === key;
          });
          var chartSeries = {
            dataItem: key
          };
          var deviceNameLabel = generateDisplayName(dataItem, deviceName, options == null ? void 0 : options.controls);
          if ((chartItem == null ? void 0 : chartItem.chartType) === _constants.CHART_LINE) {
            var _chartItem$symbol, _chartItem$symbol2, _chartItem$symbol3, _chartItem$appearance, _chartItem$appearance2, _chartItem$appearance3;
            chartSeries = Object.assign({}, chartSeries, {
              name: deviceNameLabel,
              type: _constants.CHART_LINE,
              data: value,
              color: dataItem == null ? void 0 : dataItem.color,
              xAxisIndex: index,
              yAxisIndex: index,
              symbol: chartItem == null || (_chartItem$symbol = chartItem.symbol) == null ? void 0 : _chartItem$symbol.type,
              showSymbol: chartItem == null || (_chartItem$symbol2 = chartItem.symbol) == null ? void 0 : _chartItem$symbol2.show,
              symbolSize: chartItem == null || (_chartItem$symbol3 = chartItem.symbol) == null ? void 0 : _chartItem$symbol3.size,
              markPoint: (0, _SeriesOptions.getStatisticsPointsOptions)(options == null ? void 0 : options.statistics, valueFormatter),
              markLine: (0, _SeriesOptions.getMarkLinesOptions)(options == null ? void 0 : options.statistics, chartItem, targetValue, valueFormatter, uiModern),
              smooth: chartItem == null || (_chartItem$appearance = chartItem.appearance) == null ? void 0 : _chartItem$appearance.smooth,
              step: chartItem == null || (_chartItem$appearance2 = chartItem.appearance) == null ? void 0 : _chartItem$appearance2.step
            });
            if (chartItem != null && (_chartItem$appearance3 = chartItem.appearance) != null && (_chartItem$appearance3 = _chartItem$appearance3.areaStyles) != null && _chartItem$appearance3.show) {
              chartSeries.areaStyle = {};
            }
          } else if ((chartItem == null ? void 0 : chartItem.chartType) === _constants.CHART_BAR) {
            var _chartItem$appearance4, _chartItem$appearance5, _chartItem$appearance6;
            chartSeries = Object.assign({}, chartSeries, {
              name: deviceNameLabel,
              type: _constants.CHART_BAR,
              data: value,
              color: dataItem == null ? void 0 : dataItem.color,
              xAxisIndex: index,
              yAxisIndex: index,
              markPoint: (0, _SeriesOptions.getStatisticsPointsOptions)(options == null ? void 0 : options.statistics, valueFormatter),
              markLine: (0, _SeriesOptions.getMarkLinesOptions)(options == null ? void 0 : options.statistics, chartItem, targetValue, valueFormatter, uiModern),
              showBackground: chartItem == null || (_chartItem$appearance4 = chartItem.appearance) == null ? void 0 : _chartItem$appearance4.showBackground
            }, uiModern ? {
              backgroundStyle: {
                color: "#EFF2F4",
                borderRadius: [4, 4, 0, 0]
              },
              // Stacked segments stay square so they meet without seams.
              itemStyle: {
                borderRadius: chartItem != null && (_chartItem$appearance5 = chartItem.appearance) != null && _chartItem$appearance5.stackData ? 0 : [4, 4, 0, 0]
              }
            } : {}, {
              stack: chartItem != null && (_chartItem$appearance6 = chartItem.appearance) != null && _chartItem$appearance6.stackData ? "total" : ""
            });
          } else if ((chartItem == null ? void 0 : chartItem.chartType) === _constants.CHART_SCATTER) {
            var _chartItem$symbol4, _chartItem$symbol5, _chartItem$symbol6;
            chartSeries = Object.assign({}, chartSeries, {
              name: deviceNameLabel,
              type: _constants.CHART_SCATTER,
              data: value,
              color: dataItem == null ? void 0 : dataItem.color,
              xAxisIndex: index,
              yAxisIndex: index,
              symbol: chartItem == null || (_chartItem$symbol4 = chartItem.symbol) == null ? void 0 : _chartItem$symbol4.type,
              showSymbol: chartItem == null || (_chartItem$symbol5 = chartItem.symbol) == null ? void 0 : _chartItem$symbol5.show,
              symbolSize: (chartItem == null || (_chartItem$symbol6 = chartItem.symbol) == null ? void 0 : _chartItem$symbol6.size) || 4,
              markPoint: (0, _SeriesOptions.getStatisticsPointsOptions)(options == null ? void 0 : options.statistics, valueFormatter),
              markLine: (0, _SeriesOptions.getMarkLinesOptions)(options == null ? void 0 : options.statistics, chartItem, targetValue, valueFormatter, uiModern)
            });
          }
          series.push(chartSeries);
        };
        for (var _i4 = 0, _Object$entries4 = Object.entries(_groupedData); _i4 < _Object$entries4.length; _i4++) {
          _loop2();
        }
      }
    }
  });
  return series;
};
var calculateRingWidth = function calculateRingWidth(radius, sizePercent) {
  return [radius - radius * sizePercent / 100 + "%", radius + "%"];
};
var calculateRingAngle = function calculateRingAngle(angle) {
  return (-angle + 90) % 360;
};
var generateDisplayName = function generateDisplayName(dataItem, deviceName, controls) {
  var displayName = dataItem == null ? void 0 : dataItem.displayName;
  if (controls != null && controls.showDeviceNameInItem) {
    displayName = deviceName + "-" + displayName;
  }
  if (controls != null && controls.showUnitInItem) {
    displayName = displayName + " (" + (dataItem == null ? void 0 : dataItem.unit) + ")";
  }
  return displayName;
};